<template>
  <div>
    <div class="list_top_box">
      <div class="float-end">
        <div class="list_top_search d-flex">
          <input
            type="text"
            id="searchWord"
            v-model="form.searchWord"
            name="searchWord"
            value=""
            class="m-1 form-control"
          />
          <select id="searchClass" v-model="form.searchClass" class="m-1 form-control">
            <option value="">--{{ $t("common.classify") }}--</option>
            <option
              v-for="(clazz, index) in classList"
              :key="index"
              :value="clazz.classId"
            >
              {{ clazz.className }}
            </option>
          </select>
          <select id="searchState" v-model="form.searchState" class="m-1 form-control">
            <option value="">--{{ $t("common.state") }}--</option>
            <option value="Y">{{ $t("support.qna.answered") }}</option>
            <option value="N">{{ $t("support.qna.answering") }}</option>
          </select>
          <a id="btnSearch" @click="searchBtn" href="#" class="btn btn-primary btn-sm">{{
            $t("common.search")
          }}</a>
        </div>
      </div>
    </div>
    <div class="faq_list_top">
      <div v-if="this.$session.get('userName') != null" class="lt_right">
        <router-link to="/support/qna/form" class="btn btn-primary btn-sm">{{
          $t("common.register")
        }}</router-link>
      </div>
    </div>
    <div>
      <table class="list_tbl">
        <thead>
          <tr>
            <th class="mobile_row">{{ $t("common.title") }}</th>
            <th class="mobile_h">{{ $t("common.classify") }}</th>
            <th class="mobile_h">{{ $t("common.state") }}</th>
            <th class="mobile_h">{{ $t("common.writer") }}</th>
            <th class="mobile_h">{{ $t("common.date") }}</th>
            <th class="mobile_h">{{ $t("common.file") }}</th>
            <th class="mobile_h">{{ $t("common.hits") }}</th>
          </tr>
        </thead>
        <tbody v-if="items.length != 0">
          <tr
            v-for="(item, index) in items"
            :key="index"
            @click="goQnaView(item.boardId)"
            class="active_mouseover"
          >
            <td class="pointer text-left">
              {{ item.title }}
            </td>
            <td>{{ item.className }}</td>
            <td>
              {{
                item.state == "Y"
                  ? $t("support.qna.answered")
                  : $t("support.qna.answering")
              }}
            </td>
            <td>{{ item.firstRegrName }}</td>
            <td>{{ item.firstRegDatetime }}</td>
            <td v-if="item.filecount > 0">
              <img src="../../../src/img/background/view_file_icon.png" alt="file" />
            </td>
            <td v-else></td>
            <td>{{ item.hitno }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7">{{ $t("common.noData") }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="items.length != 0" class="paging_nav">
      <a
        href="#"
        v-if="pagingVO.startPage <= pagingVO.blockSize"
        class="page_select prev_page disabled"
        >이전페이지 이동</a
      >
      <a
        v-else
        class="page_select prev_page"
        @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
        v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
        >이전페이지 이동</a
      >
      <span
        v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
        :key="index"
      >
        <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
          pagingVO.startPage + index
        }}</strong>
        <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
          pagingVO.startPage + index
        }}</a>
      </span>
      <a
        v-if="pagingVO.endPage >= pagingVO.totalPage"
        href="#"
        class="page_select next_page disabled"
        >다음페이지 이동</a
      >
      <a
        v-else
        href="#"
        @click="searchPage(pagingVO.endPage + 1)"
        v-bind:data-page="pagingVO.endPage + 1"
        class="page_select next_page"
        >다음페이지 이동</a
      >
    </div>
  </div>
</template>

<script>
import { getMyQnaList } from "@/api/myqna";

export default {
  data() {
    return {
      items: "",
      pagingVO: "",
      form: {
        searchWord: "",
        searchState: "",
        searchClass: "",
        startDate: "",
        endDate: "",
        page: 1,
      },
      classList: [],
      boardId: "",
      component: null,
      componentName: null,
    };
  },
  mounted() {
    if (this.$store.getters.getPage != 1) {
      this.form.page = this.$store.getters.getPage;
      this.fetchData(this.form.page);
    } else {
      this.fetchData(this.form.page);
    }
  },
  methods: {
    async fetchData(page) {
      try {
        if (
          this.$store.getters.getSearchWord != "" ||
          this.$store.getters.getSearchWord != undefined
        ) {
          this.form.searchWord = this.$store.getters.getSearchWord;
        }
        this.form.page = page;
        const response = await getMyQnaList(this.form);
        this.items = response.data.pagingVO.dataList;
        this.pagingVO = response.data.pagingVO;
        this.classList = response.data.classList;
        if (this.pagingVO.endPage > this.pagingVO.totalPage) {
          this.pagingVO.endPage = this.pagingVO.totalPage;
        }
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.fetchData(this.form.page);
    },
    searchBtn() {
      // 검색기능
      this.form.page = 1;
      this.$store.commit("setSearchWord", this.form.searchWord);
      this.fetchData(this.form.page);
    },
    goQnaView(boardId) {
      this.$router.push({ name: "qnaDetail", query: { boardId: boardId } });
      // this.$router.push({ name: "qnaDetail", params: { boardId: boardId } });
    },
  },
};
</script>

<style></style>
